// extracted by mini-css-extract-plugin
export default {"layout":"TermsConditionsConfirmationPopup__layout--2Pr","innerContent":"TermsConditionsConfirmationPopup__innerContent--1TV","info":"TermsConditionsConfirmationPopup__info--367"};